import React, { Component } from 'react';
import Link from 'react-router-dom/Link'
import Button from '../button/button';
import './newsblockfrontpage.css';

class Newsblockfrontpage extends Component {

    render() {

        return (
            <div className="newsblockfrontpage" style={{backgroundImage: `url('${this.props.image}')`}}>
                <Link to={`/actueel/${this.props.slug}`}>
                    <div className="newsblockfrontpage__newsdetails">
                        <div className="newsblockfrontpage__category">{ this.props.category }</div>
                        <div className="newsblockfrontpage__title">{ this.props.title }</div>
                        <Button href={`/actueel/${this.props.slug}`} name="Lees meer" color="transparent" bordercolor="white" textcolor="white"/>
                    </div>
                </Link>
            </div>
        );
    }
}

export default Newsblockfrontpage;



// WEBPACK FOOTER //
// ./src/components/newsblockfrontpage/newsblockfrontpage.js